import React from 'react'

export const InfoTitle = ({ children }) => (
  <div className="padding-vertical-medium bold border-bottom-small border-shade-50">
    {children}
  </div>
)

export const Section = ({ children }) => (
  <div className="padding-bottom-medium">{children}</div>
)

export const StatisticsContainer = ({ children }) => (
  <div className="flexbox flexbox-align-center padding-medium center-text shade-10">
    {children}
  </div>
)

export const StatisticsCountItem = ({ children }) => (
  <div className="flexbox-grow">{children}</div>
)

export const StatisticsInfoItem = ({ children }) => (
  <div className="shade-10 center-text width-full padding-bottom-medium">
    {children}
  </div>
)

export const Item = ({ children }) => (
  <div className="padding-vertical-normal border-bottom-small border-shade-50 shade-10">
    {children}
  </div>
)
